// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__30fcD","range":"MonthRangeSwitch_range__2zrU9","disabled":"MonthRangeSwitch_disabled__1-i-Y"};